import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useEventApi() {
  const callApi = useApiCall();

  // const

  const eventList = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_LIST, data, onSuccess, onError);
  };

  const eventGameList = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME, data, onSuccess, onError);
  };

  const eventGameDetails = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_DETAILS, data, onSuccess, onError);
  };

  const upcomingEventList = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_UPCOMING_EVENT, data, onSuccess, onError);
  };

  const pickRider = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.PICK_RIDER, data, onSuccess, onError);
  };

  const viewLeaderBoard = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.LEADERBOARD, data, onSuccess, onError);
  };

  const joinEventGame = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.JOIN_EVENT_GAME, data, onSuccess, onError);
  };

  const tvImageList = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.TV_IMAGE.DETAILS, data, onSuccess, onError, false);
  };

  const saveVote = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.SAVE_VOTE, data, onSuccess, onError);
  };

  const getGameDetails = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GAME_DETAILS, data, onSuccess, onError);
  };

  const prizeDetails = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.PRIZE_DETAILS, data, onSuccess, onError);
  };

  const getRodeoEventGeoLocations = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS, data, onSuccess, onError);
  };

  const getLeaderboardLocationList = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.LEADERBOARD_LOCATION_LIST, data, onSuccess, onError);
  };

  const performanceList = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.PERFORMANCE_LIST, data, onSuccess, onError);
  };

  const winningTicketResults = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.WINNING_TICKET_RESULTS, data, onSuccess, onError);
  };

  const getMyTeam = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_MY_TEAM, data, onSuccess, onError);
  };

  const mostPopularPicks = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.MOST_POPULAR_PICKS, data, onSuccess, onError);
  };

  const getShareImageLink = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_SHARE_IMAGE_LINK, data, onSuccess, onError);
  };

  const yourPicks = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.YOUR_PICKS, data, onSuccess, onError);
  };

  const getGameStatusText = (data: Record<string, unknown>, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GAME_STATUS_TEXT, data, onSuccess, onError);
  };

  const scanQRCode = (data: Record<string, unknown> | FormData, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.EVENT.SCAN_QR_CODE, data, onSuccess, onError);
  };

  return {
    callGetEventList: eventList,
    callGetUpcomingEventList: upcomingEventList,
    callGetEventGameList: eventGameList,
    callGetEventGameDetails: eventGameDetails,
    callPickRider: pickRider,
    callViewLeaderBoard: viewLeaderBoard,
    callTvImageDetails: tvImageList,
    callJoinEventGame: joinEventGame,
    callSaveVote: saveVote,
    callGetGameDetails: getGameDetails,
    callPrizeDetails: prizeDetails,
    callGetRodeoEventGeoLocations: getRodeoEventGeoLocations,
    callGetLeaderboardLocationList: getLeaderboardLocationList,
    callPerformanceList: performanceList,
    callWinningTicketResults: winningTicketResults,
    callGetMyTeam: getMyTeam,
    callMostPopularPicks: mostPopularPicks,
    callGetShareImageLink: getShareImageLink,
    callYourPicks: yourPicks,
    callGetGameStatusText: getGameStatusText,
    callScanQRCode: scanQRCode,
  };
}
